import { render } from "./FailedVerification.vue?vue&type=template&id=1438a465&scoped=true"
import script from "./FailedVerification.vue?vue&type=script&lang=js"
export * from "./FailedVerification.vue?vue&type=script&lang=js"

import "./FailedVerification.vue?vue&type=style&index=0&id=1438a465&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1438a465"]])

export default __exports__